import { getSupportedLocale } from '@ms/yammer-i18n';
import { Action } from 'redux';

import { Locale } from '../../state/types';

export interface LocaleSetAction extends Action {
  readonly type: '@@yammer-i18n-react/LOCALE.SET';
  readonly payload: Locale;
}

export const setLocale: (locale: Locale) => LocaleSetAction = (locale) => {
  const supportedLocale = getSupportedLocale(locale);

  return {
    type: '@@yammer-i18n-react/LOCALE.SET',
    payload: supportedLocale,
  };
};
